import { Cancel, CheckCircle, Visibility } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'

import { isPvOnly } from '../../appointment.utils.ts'
import type { Appointment } from '../../types.ts'
import Header from '../Header'

interface Props {
  appointment: Appointment
}

export const SectionDataCollection = ({ appointment }: Props) => {
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      <Header label="Data Collection Status" />
      <Box display="flex" alignItems="center" gap={1}>
        {appointment.dataCollected ? (
          <>
            <CheckCircle color="success" />
            <Typography variant="body2" color="success.main">
              Data collected
            </Typography>
            {/* Pv-only appointments have no data-collection form —
                          they're marked dataCollected once completed just to
                          stop showing up as pending, but there's no actual
                          submission for appointly's viewer to show. */}
            {!isPvOnly(appointment) && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<Visibility />}
                href={`https://appointly.enter.de/viewer/${appointment.buildingUUID}?type=${appointment.type}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                View
              </Button>
            )}
          </>
        ) : (
          <>
            <Cancel color="error" />
            <Typography variant="body2" color="error.main">
              Data not collected
            </Typography>
          </>
        )}
      </Box>
    </Box>
  )
}

export default SectionDataCollection
